import API from './api';

export const generateSalarySlip = async (mobileNumber, monthYear, advanceDeductionAmount, professionalTax, foodAllowance, travelAllowance, materialReimbursement, materialReimbursementNarration, bonus, bonusNarration) => {
  try {
    const slipData = {
      mobileNumber,
      monthYear,
      advanceDeductionAmount,
      professionalTax,
      foodAllowance,
      travelAllowance,
      materialReimbursement,
      materialReimbursementNarration,
      bonus,
      bonusNarration,
    };
    const response = await API.post('/salary-slips', slipData);
    return response.data;
  } catch (error) {
    console.error(`Error generating salary slip for ${mobileNumber}:`, error);
    throw error;
  }
};

export const updateSalarySlip = async (mobileNumber, year, month, slipData) => {
  try {
    const response = await API.put(`/salary-slips/${mobileNumber}/${year}/${month}`, slipData);
    return response.data;
  } catch (error) {
    console.error(`Error updating salary slip for ${mobileNumber}:`, error);
    throw error;
  }
};

export const getSalarySlip = async (mobileNumber, year, month) => {
  try {
    const response = await API.get(`/salary-slips/${mobileNumber}/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching salary slip for ${mobileNumber}:`, error);
    throw error;
  }
};

export const listSalarySlipsForUser = async (mobileNumber) => {
  try {
    const response = await API.get(`/salary-slips/${mobileNumber}`);
    return response.data;
  } catch (error) {
    console.error(`Error listing salary slips for ${mobileNumber}:`, error);
    throw error;
  }
};

export const listSalarySlipsForMonth = async (year, month) => {
  try {
    const response = await API.get(`/salary-slips/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error listing salary slips for ${year}-${month}:`, error);
    throw error;
  }
};

export const regenerateSalarySlipPdf = async (mobileNumber, year, month) => {
  try {
    const response = await API.post(`/salary-slips/${mobileNumber}/${year}/${month}/regenerate-pdf`);
    return response.data;
  } catch (error) {
    console.error(`Error regenerating salary slip PDF for ${mobileNumber}:`, error);
    throw error;
  }
};

export const deleteSalarySlip = async (mobileNumber, year, month) => {
  try {
    const response = await API.delete(`/salary-slips/${mobileNumber}/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting salary slip for ${mobileNumber}:`, error);
    throw error;
  }
};

export const recalculateSalaryAfterAttendanceUpdate = async (mobileNumber, year, month) => {
  try {
    const response = await API.post(`/salary-slips/${mobileNumber}/${year}/${month}/recalculate`);
    return response.data;
  } catch (error) {
    console.error(`Error recalculating salary for ${mobileNumber}:`, error);
    throw error;
  }
};


